import { Badge } from '@/components/ui/badge';
import { focusToTitle, getFocusIcon } from '@/lib/focus-display';
import { cn } from '@/lib/utils';

interface ComposerFocusChipProps {
  focusKey: string;
  className?: string;
}

export function ComposerFocusChip({ focusKey, className }: ComposerFocusChipProps) {
  const label = focusToTitle(focusKey);

  return (
    <Badge
      variant="secondarySoft"
      className={cn(
        'inline-flex max-w-full items-center gap-1.5 font-normal text-muted-foreground',
        className
      )}
      title={`Current focus: ${label}`}
    >
      {getFocusIcon(focusKey, 'size-3.5 shrink-0')}
      <span className="truncate">{label}</span>
    </Badge>
  );
}
